<template>
  <div class="flex gap-2">
    <div class="avatar avatar-placeholder h-8">
      <div class="h-8 w-8 rounded-full" :class="hashedColorClass" :style="hashedColorStyle">
        <FontAwesomeIcon :icon="sourceTypeInfo.icon" />
      </div>
    </div>
    <div class="flex flex-col overflow-hidden text-left whitespace-nowrap">
      <div class="max-w-full overflow-hidden text-xs font-semibold text-ellipsis lg:text-sm">
        {{ source?.name ?? $t('source.all-sources') }}
      </div>
      <div class="text-xs" :class="sourceTypeInfo.className">{{ sourceTypeInfo.title }}</div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { SourceType, type RefSourceDto } from '@konsolenkost-de/acquisition_store_server_sdk_vue';
import { computed } from 'vue';
import { useSourceTypeInfo } from '../../composables/source/useSourceTypeInfo';
import {
  HashedColorThemeAvatar,
  useHashedBackgroundColor,
} from '../../composables/style/useHashedBackgroundColor';

const props = defineProps<{
  source: RefSourceDto | null;
}>();

const sourceName = computed(() => props.source?.name ?? '');
const sourceType = computed(() => props.source?.type ?? 'global');

const { sourceTypeInfo } = useSourceTypeInfo('text', sourceType);
const { hashedColorClass, hashedColorStyle } = useHashedBackgroundColor(
  sourceName,
  HashedColorThemeAvatar,
);
</script>
